// extracted by mini-css-extract-plugin
export var modal = "_go-0";